import React from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

import './Coupon.scss';
import coupon1Left from '../../../assets/images/cards/card1_left.png';
import coupon1Right from '../../../assets/images/cards/card1_right.png';
import coupon2Left from '../../../assets/images/cards/card2_left.png';
import coupon2Right from '../../../assets/images/cards/card2_right.png';
import coupon3Left from '../../../assets/images/cards/card3_left.png';
import coupon3Right from '../../../assets/images/cards/card3_right.png';
import coupon4Left from '../../../assets/images/cards/card4_left.png';
import coupon4Right from '../../../assets/images/cards/card4_right.png';
import coupon5Left from '../../../assets/images/cards/card5_left.png';
import coupon5Right from '../../../assets/images/cards/card5_right.png';
import coupon6Left from '../../../assets/images/cards/card6_left.png';
import coupon6Right from '../../../assets/images/cards/card6_right.png';
import coupon7Left from '../../../assets/images/cards/card7_left.png';
import coupon7Right from '../../../assets/images/cards/card7_right.png';
import coupon8Left from '../../../assets/images/cards/card8_left.png';
import coupon8Right from '../../../assets/images/cards/card8_right.png';
import Button from 'src/components/Button/Button';

interface CouponInterface {
  matrix: {
    serialDevice: string,
    cardId: string,
    cardName: string,
    columns: number
    matrix: string[]
  }
}

function Coupon({ matrix }: CouponInterface) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const Components = {
    coupon1Left,
    coupon1Right,
    coupon2Left,
    coupon2Right,
    coupon3Left,
    coupon3Right,
    coupon4Left,
    coupon4Right,
    coupon5Left,
    coupon5Right,
    coupon6Left,
    coupon6Right,
    coupon7Left,
    coupon7Right,
    coupon8Left,
    coupon8Right
  };

  const handleClear = () => {
    dispatch.peripherals.resetMatrix();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await dispatch.peripherals.submitNewMatrix({ matrix: JSON.stringify(matrix.matrix) });
  };

  return (
    <div className="coupon">
      <div className="coupon__image">
        <div className="coupon__left">
          <img src={ Components[`coupon${ matrix.cardId }Left`] } />
        </div>
        <div className="coupon__right">
          <img src={ Components[`coupon${ matrix.cardId }Right`] } />
          <table className="coupon__table" >
            <tbody>
              {
                _.map(matrix.matrix, (col, ci) => (
                  <tr
                    key={ ci }
                  >
                    {
                      _.map(matrix.matrix[ci], (line, li) => (
                        <td
                          key={ li }
                          className={
                            classNames({
                              'coupon__cell': true,
                              'coupon__cell--selected': line === '1',
                              'coupon__cell--selectable': line === '1' || line === '0'
                            })
                          }
                          { ...((line !== '.' && li !== matrix.matrix[ci].length -1) &&
                            { onClick: () => dispatch.peripherals.changeMatrix({ ci, li }) }) }
                        />
                      ))
                    }
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      </div>
      <div className="coupon__buttons">
        <Button text={ t('omr.clear') } onClick={ handleClear } className="coupon__btn btn--primary" />
        <Button text={ t('omr.submit') } onClick={ handleSubmit } className="coupon__btn btn--primary" />
        <Button text={ t('omr.lastCard') }  onClick={ dispatch.peripherals.getLastMatrix } className="coupon__btn btn--primary" />
      </div>
    </div>
  );
}

export default Coupon;
